/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SimpleFailureStatusVm
 */
export interface SimpleFailureStatusVm {
    /**
     * 
     * @type {string}
     * @memberof SimpleFailureStatusVm
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleFailureStatusVm
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SimpleFailureStatusVm
     */
    isSealed?: boolean;
}

export function SimpleFailureStatusVmFromJSON(json: any): SimpleFailureStatusVm {
    return SimpleFailureStatusVmFromJSONTyped(json, false);
}

export function SimpleFailureStatusVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimpleFailureStatusVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'isSealed': !exists(json, 'isSealed') ? undefined : json['isSealed'],
    };
}

export function SimpleFailureStatusVmToJSON(value?: SimpleFailureStatusVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'isSealed': value.isSealed,
    };
}


